import type { Schemas } from '../contract/types.ts'
import type { TalerClient } from '../http/client.ts'
import { type CacheKey, ledgerKey } from '../http/keys.ts'

export interface Tag {
  readonly tag: string
  readonly usageCount: number
}

export const tagKeys = {
  list: (ledgerId: string): CacheKey => ledgerKey(ledgerId, 'tags', 'list'),
} as const

export interface TagsRepository {
  /** Server-ordered, most-used first - see `packages/testing/src/server/handlers/tags.ts`. */
  list(ledgerId: string, signal?: AbortSignal): Promise<readonly Tag[]>
}

export function createTagsRepository(client: TalerClient): TagsRepository {
  return {
    async list(ledgerId, signal) {
      const tags = await client.call<Schemas['TagResponse'][]>({
        method: 'GET',
        path: `/api/v1/ledgers/${encodeURIComponent(ledgerId)}/tags`,
        ...(signal === undefined ? {} : { signal }),
      })
      return tags.map((response) => ({ tag: response.tag, usageCount: response.usageCount }))
    },
  }
}
